import { API_BASE_URL } from '../config';

export type EmployeeHirePeriodRowApi = {
  id: number;
  invitationId: string;
  periodNo: number;
  status: string;
  hireDate: string;
  occupation: string;
  dismissalDate: string;
  dismissalReason: string;
  archivePath: string;
  finalizedAt: string;
};

export async function fetchEmployeeHirePeriods(email: string): Promise<EmployeeHirePeriodRowApi[]> {
  const res = await fetch(
    `${API_BASE_URL}/api/employees/${encodeURIComponent(email.trim())}/hire-periods`
  );
  if (!res.ok) {
    throw new Error('雇用履歴の取得に失敗しました。');
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function postEmployeeResign(
  email: string,
  payload: { dismissalDate?: string; dismissalReason?: string }
): Promise<EmployeeHirePeriodRowApi> {
  const res = await fetch(
    `${API_BASE_URL}/api/employees/${encodeURIComponent(email.trim())}/hire-periods/resign`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }
  );
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || '退職の記録に失敗しました。');
  }
  return res.json();
}

export type PrepareRehireResult = {
  email: string;
  name: string;
  message: string;
};

/** Clears finalize flags and sets status to registered so create-invitation can include them. */
export async function postPrepareRehire(email: string): Promise<PrepareRehireResult> {
  const res = await fetch(
    `${API_BASE_URL}/api/employees/${encodeURIComponent(email.trim())}/prepare-rehire`,
    { method: 'POST' }
  );
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    try {
      const data = JSON.parse(text) as { message?: string };
      if (typeof data?.message === 'string' && data.message.trim()) {
        throw new Error(data.message);
      }
    } catch (e) {
      if (e instanceof Error && !(e instanceof SyntaxError)) throw e;
    }
    throw new Error(text || '再雇用の準備に失敗しました。');
  }
  return res.json();
}
